import styled from 'styled-components';
import { COLORS } from '@/theme/theme';
import { media } from '@/styles/Qtheme';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 552px;

  @media ${media.desktop} {
    height: 452px;
  }

  @media ${media.mobile} {
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 42px;
`;

export const Title = styled.div`
  font-size: 40px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif !important;

  @media ${media.mobile} {
    text-align: center;
  }
`;

export const TitlePrimary = styled.span`
  color: #007aff;
`;

export const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.25;
  color: ${({ theme }) => theme.COLORS.descText};

  @media ${media.mobile} {
    text-align: center;
  }
`;

export const JoinButton = styled.button`
  width: 190px;
  height: 40px;
  background-color: ${({ theme }) => theme.COLORS.tabMenuActive};
  color: ${COLORS.white};
  font-size: 14px;
  font-weight: 500;
  font-family: 'Pretendard', sans-serif !important;
  border-radius: 4px;
`;

export const JoinButtonMobile = styled.button`
  width: 190px;
  height: 40px;
  background-color: ${({ theme }) => theme.COLORS.tabMenuActive};
  color: ${COLORS.white};
  font-size: 14px;
  font-weight: 500;
  font-family: 'Pretendard', sans-serif !important;
  border-radius: 4px;

  position: absolute;
  bottom: 0;
`;

export const RightSectionWrapper = styled.div`
  height: 492px;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  @media ${media.desktop} {
    height: 442px;
  }
`;

export const RightSection = styled.div`
  overflow: hidden;
  width: 524px;
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;

  @media ${media.desktop} {
    width: 424px;
  }
`;

export const RightSectionImage = styled.img`
  position: absolute;
  top: 60px;
  width: 100%;
  object-fit: cover;
`;

export const RightSectionRotatedImage = styled.img`
  position: absolute;
  bottom: -270px;
  width: 100%;
  object-fit: cover;
  transform: rotate(180deg);
  z-index: -1;
  filter: blur(12px);
  opacity: 0.3;

  @media ${media.desktop} {
    bottom: -170px;
  }
`;

export const CoinCenter = styled.img`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  filter: drop-shadow(0px 10px 50px rgba(0, 0, 0, 0.1));
`;

export const CoinLeft = styled.img`
  position: absolute;
  top: 100px;
  left: 40px;
  filter: drop-shadow(0px 10px 50px rgba(0, 0, 0, 0.15));
`;

export const CoinRight = styled.img`
  position: absolute;
  top: 110px;
  right: 40px;
  filter: drop-shadow(0px 10px 50px rgba(0, 0, 0, 0.15));
`;

export const RightSectionLayout = styled.img`
  position: absolute;
  width: 700px;
  top: -30px;
  left: -80px;
  object-fit: cover;
  z-index: -1;

  @media ${media.desktop} {
    width: 500px;
    top: 0;
    left: -5px;
  }
`;
